export function useCookieConsent() {
  const categories = useState<ConsentCategories>('cookieConsent', () => NO_CONSENT)
  const resolved = useState('cookieConsentResolved', () => false)
  const analytics = computed(() => categories.value.analytics)

  return {
    categories,
    analytics,
    resolved,
  }
}

